export const doi_policy_framework = [
  {
    id: 1,
    name: 'NPC-National-Development-Plan-Vision-2030',
    summary: 'shortsummary/NPC-National-Development-Plan-Vision-2030.html',
    link: 'NPC-National-Development-Plan-Vision-2030.pdf',
    audio_en: 'audio/en/NPC-National-Development-Plan-Vision-2030_en.mp3',
    audio_af: 'audio/af/NPC-National-Development-Plan-Vision-2030_af.mp3',
    audio_xh: 'audio/xh/NPC-National-Development-Plan-Vision-2030_xh.mp3'
  }
];